import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'toDate'
})
export class ToDatePipe implements PipeTransform {
    transform(time: string | null | undefined): Date | null {
        if (!time) return null;
        return new Date(`1970-01-01T${time}`);
    }
}
